import { render, staticRenderFns } from "./RegistryDialog.vue?vue&type=template&id=b5d005a4&scoped=true&"
import script from "./RegistryDialog.vue?vue&type=script&lang=js&"
export * from "./RegistryDialog.vue?vue&type=script&lang=js&"
import style0 from "./RegistryDialog.vue?vue&type=style&index=0&id=b5d005a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d005a4",
  null
  
)

export default component.exports